import React from 'react'

import { useTransition, animated } from '@react-spring/web'

import { MODAL_BG_CLASS } from '@web/libs/constants'
import { ClickHandler } from '@web/types'

const generateBackgroundStyle = ({ bgColor }: { bgColor?: string }) => {
  if (bgColor === 'white')
    return {
      from: { background: 'rgba(255, 255, 255, 0)' },
      enter: { background: 'rgba(255, 255, 255, 0.8)' },
      leave: { background: 'rgba(255, 255, 25, 0)' },
    }

  return {
    from: { background: 'rgba(0, 0, 0, 0)' },
    enter: { background: 'rgba(0, 0, 0, 0.4)' },
    leave: { background: 'rgba(0, 0, 0, 0)' },
  }
}

interface Props {
  show: boolean
  bgColor?: 'white' | 'black'
  onClick?: ClickHandler
}

const ModalBackground: React.FC<Props> = ({ show, bgColor, onClick }) => {
  const bgTransitons = useTransition(show, generateBackgroundStyle({ bgColor }))

  return bgTransitons(
    (springStyle, item) =>
      item && (
        <animated.div
          role="presentation"
          aria-hidden="true"
          className={MODAL_BG_CLASS}
          style={springStyle}
          onClick={onClick}
        />
      ),
  )
}

export default ModalBackground
